// extracted by mini-css-extract-plugin
export var table = "matrix-figure-module--table--qBiy5";
export var row = "matrix-figure-module--row--nmTEb";
export var easterEgg = "matrix-figure-module--easterEgg--kgfkI";
export var cube = "matrix-figure-module--cube--eV2hB";
export var cubeAnimationContainer = "matrix-figure-module--cubeAnimationContainer--HWSI-";